import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.3469 20C15.9503 20 20.4927 15.5228 20.4927 10C20.4927 4.47715 15.9503 0 10.3469 0C4.74359 0 0.201172 4.47715 0.201172 10C0.201172 15.5228 4.74359 20 10.3469 20Z",
      fill: "#23AA71"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.2083 7.21176C14.9256 6.92979 14.4667 6.92969 14.1837 7.21176L9.12196 12.2567L7.52618 10.6662C7.24319 10.3843 6.78444 10.3842 6.50155 10.6663C6.21856 10.9483 6.21856 11.4055 6.50155 11.6876L8.6097 13.7887C8.75119 13.9297 8.93658 14.0002 9.12206 14.0002C9.30755 14.0002 9.49293 13.9297 9.63443 13.7887L15.2083 8.23304C15.4912 7.95107 15.4912 7.49382 15.2083 7.21176",
      fill: "#F2F2F2"
    }, null, -1)
  ])))
}
export default { render: render }